export default "__VITE_ASSET__411830b4__"